import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router
} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';

import { SessionService } from '../../api/session.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    protected sessionService: SessionService,
    protected router: Router
  ) {}

  canActivate() {
    const hasEmail: string = this.sessionService.email;

    if (!hasEmail)
      this.router.navigate(['/login']);

    return Observable.of(!!hasEmail);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/guards/auth-guard.ts